import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import AddLookup from "../../../Components/InputComponents/AddLookup";
import { errorNotify } from "../../../Components/ToastComponent/ToastNotification";

function AddRecruitmentCountry() {
  const [searchParams] = useSearchParams();
  const redirectURL = `/RecruitmentCountryLookup?${searchParams.toString()}`;
  const [countries, setCountries] = useState();

  const getCountries = () => {
    axiosAPI
      .get(`/RecruitmentCountry/listCountry`)
      .then((res) => {
        const options = res?.data?.data
          .map((item) => ({
            label: item.CL_Name,
            value: item.CL_ID,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));

        setCountries(options);
      })
      .catch((err) => {
        errorNotify(`Something went wrong`);
      });
  };

  useEffect(() => {
    getCountries();
  }, []);

  return (
    <AddLookup
      title="Add Recruitment Country"
      alert="Recruitment Country Added Successfully"
      addDataAPIEndpoint="/RecruitmentCountry/add"
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "select",
              label: "Recruitment Country",
              name: "RC_Name",
              required: true, // Validation rule added here
              options: countries ? countries : [],
            },
            {
              type: "select",
              label: "Status",
              name: "RC_Status",
              required: true, // Validation rule added here
              options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        RC_Name: {
          required: true,
        },
        RC_Status: {
          required: true,
        },
      }}
    />
  );
}

export default AddRecruitmentCountry;
